var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHead = function SvgHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 160,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M150.93 78.106c0-35.383-25.948-64.044-58.047-64.044s-58.047 28.66-58.047 64.044c0 11.465 2.687 22.151 7.495 31.492 7.848 15.357 11.666 32.483 11.666 49.75V166h77.843v-6.652c0-17.267 3.747-34.393 11.666-49.75a70.5 70.5 0 0 0 7.424-31.492Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M112.679 37.203H24.726v84.496h87.953z"
  })));
};
export default SvgHead;